import styled from "styled-components";
import OptionFlow from "../../SelectBox/components/Option";
import * as Styled from "../../SelectBox/styled";
export const Option = styled(OptionFlow) `
  text-align: center;

  &.hasHighlight {
    border-top: 0;

    ${Styled.OptionContainer} & {
      border-top-left-radius: 0 !important;
      border-top-right-radius: 0 !important;
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3B0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvT3JkZXJSZXNvdXJjZVNlbGVjdC9zdHlsZWQvT3B0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sVUFBVSxNQUFNLG1DQUFtQyxDQUFDO0FBQzNELE9BQU8sS0FBSyxNQUFNLE1BQU0sd0JBQXdCLENBQUM7QUFFakQsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxVQUFVLENBQUMsQ0FBQTs7Ozs7O01BTWxDLE1BQU0sQ0FBQyxlQUFlOzs7OztDQUszQixDQUFDIn0=